/* eslint-disable extra-rules/no-commented-out-code */
// Message State constants
export const MESSAGE_STATE_NEW = "new";
export const MESSAGE_STATE_ACCEPT_ANSWER_PROMPT = "accept-answer-prompt"; // custConfirmation = true
export const MESSAGE_STATE_RATE_AMBASSADOR = "rate-ambassador"; // customerScore = <number> || !customerScore = <number> & captureCustomerReview = <boolean>
export const MESSAGE_CUSTOMER_OPINION_SCORE = "customer-opinion-score";
export const MESSAGE_CUSTOMER_OPINION_ACCEPT = "customer-opinion-accept";
export const MESSAGE_STATE_PENDING_CLOSURE = "pending-closure"; //accepted but not custResolved and not auto resolved
export const MESSAGE_STATE_CUSTOM = "pending-closure"; //accepted but not custResolved and not auto resolved
export const MESSAGE_STATE_CLOSED = "closed"; // state = closed
export const MESSAGE_STATE_SUGGESTED_ANSWER = "suggested-answer"; // last dialogue is suggested answer
export const MESSAGE_STATE_REPORTED = "reported"; // reportedAt || reportedNote || reportedReason
export const MESSAGE_STATE_TIMEDOUT = "timedout"; // state = closed & lifecycleState = timedout
export const MESSAGE_STATE_FORWARDED = "escalated"; // state = closed & lifecycleState = escalated
export const MESSAGE_STATE_RESOLVED = "resolved"; // state = closed & lifecycleState = resolved
export const MESSAGE_STATE_RATE_FINISH = "rate-and-finish";
export const MESSAGE_STATE_RERATE_YOUR_EXPERIENCE = "rerate-your-experience"; // accepted = true & others
export const FEEDBACK = "0-10-feedback";
export const EXPERT_FEEDBACK = "resolution-expert";
export const FURTHER_CONTACT = "resolution-contact";
export const MESSAGE_STATE_LOADING = "loading";
export const LAST_MESSAGE_KEY = "llm-last-message";